module.exports = __webpack_public_path__ + "media/images/front/icon_search_01-91249a39ab50770db041a58c3262bf7d.svg";